<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <h1 class="error-title">{{ $t('errors.not_found') }}</h1>
      <p class="error-message">
        {{ $t('errors.not_found_message') }}
      </p>
      <router-link :to="backLink" class="back-button">
        {{ backLabel }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { t } = useI18n()

const isAdminPath = computed(() => route.path.startsWith('/admin'))

const backLink = computed(() =>
  isAdminPath.value ? '/admin/dashboard' : '/player/lobby',
)

const backLabel = computed(() =>
  isAdminPath.value ? t('errors.go_admin_dashboard') : t('errors.back_to_lobby'),
)
</script>

<style scoped>
.not-found-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #0f1923;
  padding: 2rem;
}

.not-found-content {
  text-align: center;
  max-width: 480px;
}

.error-code {
  font-size: 8rem;
  font-weight: 900;
  line-height: 1;
  color: #00e701;
  opacity: 0.15;
  user-select: none;
}

.error-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #ffffff;
  margin-top: -1rem;
  margin-bottom: 0.75rem;
}

.error-message {
  font-size: 1rem;
  color: #b1bad3;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.back-button {
  display: inline-block;
  padding: 0.75rem 2rem;
  background-color: #00e701;
  color: #0f1923;
  font-weight: 600;
  font-size: 0.9375rem;
  border-radius: 0.5rem;
  text-decoration: none;
  transition: background-color 0.2s;
}

.back-button:hover {
  background-color: #00cc01;
  color: #0f1923;
}
</style>
